import { StressTestPanel } from "../../components/dashboard/StressTestPanel.js";
import { SuggestedPromptsTile } from "../../components/SuggestedPromptsTile.js";
import { PAGE_PROMPTS } from "../../lib/data/page-prompts.js";
import { useDocumentTitle } from "../../lib/util/use-document-title.js";
import { FireSubPageLayout } from "./_layout.js";
import { useFireContext } from "./_use-fire-context.js";

/**
 * /fire/withdrawal — Phase 13.5 extraction from /dashboard#stress-test.
 *
 * Trinity-study + sequence-of-returns + Monte Carlo against the user's
 * net worth, with strategy picker (constant 4%, Guyton-Klinger, VPW,
 * CAPE, spending-smile) and Compare tab.
 */
export function FireWithdrawalPage() {
  useDocumentTitle("FIRE — Withdrawal modeler");
  const { hideValues, fiAssetsCents, byAccountType } = useFireContext();
  return (
    <FireSubPageLayout
      title="Withdrawal modeler"
      sub="See whether your savings last through past markets, random futures and five ways of spending."
    >
      <StressTestPanel
        hideValues={hideValues}
        fiAssetsCents={fiAssetsCents}
        byAccountType={byAccountType}
      />
      <SuggestedPromptsTile prompts={PAGE_PROMPTS.fireWithdrawal} />
    </FireSubPageLayout>
  );
}
